import { lazy } from 'react';

import { option } from '@code-expert/prelude';
import { concatRoutes } from '/imports/modules/Routing';
import { quizNavSelectionAdt } from '../../shared/presentation/navigation';
import { manageQuizApi } from './ManageQuizApi';
import { editQuestionLink, editQuestionRoute, editQuizLink, editQuizRoute } from './routes';
import type { SnapshotLink } from './shared';

const QuizPage = lazy(async () => {
  const { QuizPage } = await import('./QuizPage');
  return { default: QuizPage };
});

const EditQuestion = lazy(async () => {
  const { EditQuestion } = await import('./EditQuestion');
  return { default: EditQuestion };
});

const EditQuiz = lazy(async () => {
  const { EditQuiz } = await import('./EditQuiz');
  return { default: EditQuiz };
});

export const manageQuizRouter = concatRoutes([
  editQuestionRoute.parser.map(({ taskId, questionId, snapshot }) => {
    const snapshotId = option.fromNullable(snapshot);

    const snapshotLink: SnapshotLink = (snapshotId) =>
      editQuestionLink({ taskId, questionId, snapshotId });

    return (
      <QuizPage
        api={manageQuizApi}
        taskId={taskId}
        snapshotId={snapshotId}
        snapshotLink={snapshotLink}
        selection={quizNavSelectionAdt.question(questionId)}
      >
        {({ restoreSnapshotStream, taskName }) => (
          <EditQuestion
            api={manageQuizApi}
            taskId={taskId}
            snapshotId={snapshotId}
            questionId={questionId}
            snapshotLink={snapshotLink}
            restoreSnapshotStream={restoreSnapshotStream}
            taskName={taskName}
          />
        )}
      </QuizPage>
    );
  }),
  editQuizRoute.parser.map(({ taskId, snapshot }) => (
    <QuizPage
      api={manageQuizApi}
      taskId={taskId}
      snapshotId={option.fromNullable(snapshot)}
      snapshotLink={(snapshotId) => editQuizLink({ taskId, snapshotId })}
      selection={quizNavSelectionAdt.quiz()}
    >
      {({ taskName, quiz, points }) => (
        <EditQuiz
          api={manageQuizApi}
          taskName={taskName}
          taskId={taskId}
          snapshotId={option.fromNullable(snapshot)}
          quiz={quiz}
          points={points}
        />
      )}
    </QuizPage>
  )),
]);
